import Header from "./Header";
import JobsList from "./JobsList";

function App() {
  return (
    <div className="container">
      <Header/>
      <JobsList/>
    </div>
  )
}

export default App;
